<script setup>

</script>
<template>
<i class="comm-icon">
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path d="M13.5 11C13.5 11.2652 13.3946 11.5196 13.2071 11.7071C13.0196 11.8946 12.7652 12 12.5 12H4.5C4.23478 12 3.98043 11.8946 3.79289 11.7071C3.60536 11.5196 3.5 11.2652 3.5 11V4C3.5 3.73478 3.60536 3.48043 3.79289 3.29289C3.98043 3.10536 4.23478 3 4.5 3H7L8 4.5H12.5C12.7652 4.5 13.0196 4.60536 13.2071 4.79289C13.3946 4.98043 13.5 5.23478 13.5 5.5V11Z" stroke="#174FDC" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.5 7V10" stroke="#174FDC" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 8.5H10" stroke="#174FDC" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</i>
</template>
<style scoped>

</style>